import {
  TextInput,
  required,
  ReferenceInput,
  useTranslate,
  SimpleForm,
  AutocompleteInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { RESOURCE_NAME_ITEM_CLASS } from "./constants";
import { Typography } from "@material-ui/core";
import { MediaInputField } from "../../../../lib/components";
import { MAX_RECORDS_PER_PAGE } from "../../../../lib/common";

export const styles: Styles<Theme, any> = {
  name: { display: "block" },
  number: { display: "block" },
  description: { display: "block" },
};

const useStyles = makeStyles(styles);

const ItemClassForm = ({ isEdit = false, ...rest }) => {
  const classes = useStyles(rest);
  return (
    <SimpleForm warnWhenUnsavedChanges {...rest}>
      <SectionTitle label="resources.itemClasses.fieldGroups.itemClassDetails" />

      <TextInput
        autoFocus
        source="number"
        label="resources.itemClasses.fields.number"
        helperText="resources.itemClasses.help.number"
        formClassName={classes.number}
        validate={[required()]}
        fullWidth
      />
      <TextInput
        source="name"
        label="resources.itemClasses.fields.name"
        helperText="resources.itemClasses.help.name"
        formClassName={classes.name}
        validate={[required()]}
        fullWidth
      />

      <RichTextInput
        source="description"
        label="resources.itemClasses.fields.description"
        helperText="resources.itemClasses.help.description"
        formClassName={classes.description}
      />

      <ReferenceInput
        source="parentId"
        label="resources.items.fields.parentId"
        reference={RESOURCE_NAME_ITEM_CLASS}
        perPage={MAX_RECORDS_PER_PAGE}
        sort={{ field: "name", order: "ASC" }}
        filter={isEdit ? { excludeIds: [rest?.id] } : {}}
        formClassName={classes.parent}
        key="parentId"
      >
        <AutocompleteInput
          optionText="displayLabel"
          resettable={true}
          allowEmpty={false}
          helperText="resources.items.help.parentId"
        />
      </ReferenceInput>

      <MediaInputField showUploadedFiles={isEdit} />
    </SimpleForm>
  );
};
const SectionTitle = ({ label }: { label: string }) => {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {translate(label)}
    </Typography>
  );
};
export { ItemClassForm };
